
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuOmotesandoHyakuMeitenOmotesando3BurgerImage } from "@src/constants/images";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as fellowsPageMeta } from "./fellows.mdx";
export const meta = {
  path: "/media/harajuku/omotesando_hyaku_meiten",
  title: "【表参道】表参道では百名店に選ばれている人気ハンバーガー ３選",
  description: "表参道で百名店に選ばれているトップ３の人気ハンバーガーショップをご紹介させていただきます。３つのお店それぞれの一番の特徴、人気のメニュー３選、そして表参道駅からのアクセスをご紹介させていただきます。人気メニューは写真、値段つきでご紹介しているので、それぞれのお店を比較して選んでください。",
  topImg: harajukuOmotesandoHyakuMeitenOmotesando3BurgerImage,
  author: murakamiMasanori,
  tags: ["表参道", "有名店", "おしゃれな内装", "ハンバーガー", "人気店", "まとめ記事", "1人メシ", "デート", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`表参道で百名店に選ばれている人気のハンバーガーショップを厳選しました。`}</p>
    <p>{`すべてのお店が 3 年連続食べログハンバーガー部門の百名店に選出されているほどの人気店で、表参道や原宿では知らない人も少ないお店です。そんな人気のハンバーガーショップの特徴、人気のメニュー３選を写真・値段つきでご紹介させていただきます。`}</p>
    <p>{`表参道エリアでハンバーガーをガッツリ食べたいときは、こちらの情報をチェックして人気のお店とメニューを見つけてください。`}</p>
    <h2>{`ザ グレートバーガー`}</h2>
    <InstaImage postId="B-TEJ6xjHAj" mdxType="InstaImage" />
    <p>{`原宿・表参道エリアで不動の人気を誇る原宿・表参道のハンバーガーの名店。おしゃれな若者や女性たちが集う 「裏原」 とよばれる場所に位置し、3 年連続食べログ百名店に選出されるその人気は、今やとどまる事を知りません。ガラス張りの外観から見える店内は、 本場アメリカを思わせてくれるような雰囲気です。長蛇の列を作り続けるグレイトバーガーのこだわりと人気メニューについてお伝えします。`}</p>
    <h3>{`半年かけた独自開発のバンズ`}</h3>
    <p>{`たくさんの魅力がある中でも、やはりグレートバーガーのバンズがその人気の秘密になっています。オーナーが半年かけて制作したと言われるバンズは、見た目も焦げ目が絶妙で、食感はカリっと、口の中ではフワッとした食感を楽しむことができます。`}</p>
    <h3>{`人気のハンバーガー３選`}</h3>
    <h4>{`アボカドサルサチーズバーガー（1,350 円）`}</h4>
    <InstaImage postId="BBz4tdmsp3b" mdxType="InstaImage" />
    <p>{`ザグレイトバーガー といえば、このアボカドサルサチーズバーガーが 1 番人気の絶品メニューになります。
ボリューミーな見た目に、パテ、アボカド、チーズとバランスが取れた一品。`}</p>
    <h4>{`ゴルゴンチーズバーガー(1,150 円)`}</h4>
    <InstaImage postId="B7THawsBjFX" mdxType="InstaImage" />
    <p>{`チーズ好きにはたまらない至極の一品。
ゴルゴンゾーラち＝ずの風味が肉の旨味を引き出してくれる、リピート間違いなしの一品。
こちらはキノコがトッピングされていますが、キノコにも相性バッチリ！`}</p>
    <h4>{`ダブルチーズバーガー(1,550 円)`}</h4>
    <InstaImage postId="B7n9SuhJpnG" mdxType="InstaImage" />
    <p>{`ボリューミーな食べ応えのあるダブルチーズバーガーも人気メニューの一つ。
ジューシーなパテが２層になっていて、ガッツリハンバーガーを食べたい方にはおすすめ！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道から徒歩 7 分の距離にありますが、裏腹と呼ばれるエリアに位置しているので、路地裏の方にお店があります。
人気のハンバーガーショップで、素敵なお食事をお楽しみください。`}</p>
    <GoogleMap lat={35.6617681} lng={139.699553} mdxType="GoogleMap" />
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`the burger stand fellows`}</h2>
    <InstaImage postId="BzhkhswlBFJ" mdxType="InstaImage" />
    <p>{`表参道から徒歩３分程度歩いた路地裏の一角に、緑色の外壁をしたレトロ３階建ての建物が FELLOWS(フェローズ)です。`}</p>
    <p>{`「FELLOWS(フェローズ)」もグレートバーガーと同じく 3 年連続百名店に選ばれている人気のお店で、食べログの評価は 3.77(2020 年 5 月時点)と高評価。
表参道で不動の人気を誇るハンバーガーショップの人気の秘密に迫っていきたいと思います。`}</p>
    <h3>{`炭火焼のパテがジューシーな食感`}</h3>
    <p>{`そんな FELLOWS(フェローズ)が他のお店と異なるところは、パテを炭火で焼いているところです。普通のハンバーガーショップだと、鉄板でパテを焼くことが多いと思いますが、炭火でパテを焼きます。オーダーをして待っているとき、行列に並んでいるとき、炭火でパテを焼く「ジュー、ジュー」と言う音が聞こえてくると思います。
炭火で焼いたパテは、驚くほどジューシーで口の中に肉肉しい風味が広がること間違いなし！`}</p>
    <h3>{`人気のハンバーガー３選`}</h3>
    <h4>{`アボカドチーズバーガー(1,300 円)`}</h4>
    <InstaImage postId="BYny3-SF47G" mdxType="InstaImage" />
    <p>{`通称 ABC バーガと呼ばれている FELLOWS(フェローズ)で 1 番の人気メニューになります。
たっぷりあるアボカドと、どっさり中に挟まれたチーズの相性はまさに抜群！`}</p>
    <h4>{`ベーコンチーズバーガー(1,600 円)`}</h4>
    <InstaImage postId="B7YZ9Nulf78" mdxType="InstaImage" />
    <p>{`香ばしいベーコンの風味とバーガーの肉肉しさの２つを体験できる人気のメニュー。
その肉を包んでくれるのがまろやかなチーズになっています。`}</p>
    <h4>{`ダブルパティーチーズバーガー(1,600 円)`}</h4>
    <InstaImage postId="BQxk9u2gaCt" mdxType="InstaImage" />
    <p>{`ガッツリいきたい！という方には、ダブルパティーが人気のメニューになっています。
ボリューム感のあるハンバーガーなのに、しっかり食べられてしまう！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道の A1 出口から 2,3 分という好立地に人気店 FELLOWS(フェローズ)はありますので、すぐに見つけられると思います！
FELLOWS(フェローズ)で素敵なお時間をお過ごしください！`}</p>
    <GoogleMap lat={35.6650727} lng={139.7080325} mdxType="GoogleMap" />
    <LinkWithThumbnail meta={fellowsPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`the 3rd Burger`}</h2>
    <InstaImage postId="B10wN4qAUHy" mdxType="InstaImage" />
    <p>{`表参道と青山の中間地点に位置する人気のハンバーガショップ the 3rd Burger も、3 年連続百名店に選ばれている人気店です。
他のお店と違うのは、美味しいのにお手頃な値段でハンバーガーを食べることができる点ではないかと思います。
その人気は急上昇しており、店舗数も 100 店舗を目指す勢いで拡大し、Uber Eats で販路を拡大してもいます。`}</p>
    <h3>{`自家製なのに安い`}</h3>
    <p>{`セットのドリンクと一緒に頼んでも 1,000 円前後で費用が収まるように設計されているそうなんです。美味しいハンバーガーを食べたいとなると、2,000 円近く払わないと食べられない、という業界の常識を覆したこともその人気の秘密の一つだと言えそうです。
自家製のバンズや、冷凍肉を使わず、新鮮な野菜使用する自家製のバーガーは味も絶品です！`}</p>
    <h3>{`人気のハンバーガー３選`}</h3>
    <h4>{`the オーセンティックバーガー(790 円)`}</h4>
    <InstaImage postId="B9uxFo4AbVO" mdxType="InstaImage" />
    <p>{`the 3rd Burger で一番人気のメニューになっていて、なんと時間制限があるバーガーになっています。`}<strong parentName="p">{`１４時〜しか販売していない`}</strong>{`メニューだそう。、食べたい人は時間を確認してお越しください！`}</p>
    <h4>{`the 3rd Burger(550 円)`}</h4>
    <InstaImage postId="BqoWK0sgBeT" mdxType="InstaImage" />
    <p>{`the 3rd Burger のベーシックなメニューで、値段がお手頃何のしっかりとした食感とボリュームがあるメニューになっています。
新鮮な野菜も入っているので、健康に優しい点が女子絵の人気を得ている理由の一つなのだと思います。`}</p>
    <h4>{`モッツアレラバジルバーガー ¥590`}</h4>
    <InstaImage postId="BZf5Iu0FqCZ" mdxType="InstaImage" />
    <p>{`たっぷりモッツアレラのまろやかな風味とアクセントのあるバジルが、バーガーのパテの味を最大限に引き出してくれる一品になっています。
他のお店ではあまり食べられないバーガーになっているので、人気メニューを the 3rd Burger で食してみてください〜！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道から徒歩 3 分の好立地にあることから、たくさんの人が訪れ行列を作っています。
アクセスは迷いづらい場所にあると思うので、ぜひ素敵なお食事の時間をお過ごしください！`}</p>
    <GoogleMap lat={35.6571392} lng={139.7363884} mdxType="GoogleMap" />
    <h3>{`おわりに`}</h3>
    <p>{`表参道エリアで 3 年連続百名店に選ばれている人気店のハンバーガーショップをご紹介させていただきました。どのお店のどんなメニューが一番お好みでしたでしょうか。お気に入りのハンバーガショップで素敵な食事をお過ごしください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;